<div class="panel-options-body overflow-wrapper">
    <div class="form form-horizontal">
        <div class="form-group mb-20" [class.has-error]="isEmptyLabel()">
            <label class="col-xs-12">
                {{ "control_text" | translate }}
            </label>
            <div class="col-xs-12">
                <input class="form-control" [value]="label()" (input)="onLabelChange($event)" />
                @if (isEmptyLabel()) {
                    <span class="help-block small">
                        {{ "control_errors_required" | translate }}
                    </span>
                }
            </div>
        </div>

        <ng-content select=".after-text"></ng-content>

        <div class="form-row mb-20">
            <div class="form-group">
                <label class="col-xs-12">
                    {{ "control_style" | translate }}
                </label>
                <div class="col-xs-6">
                    <select class="form-control" (change)="onStyleTypeChange($event)">
                        <option
                            [value]="EButtonStyleType.primary"
                            [selected]="styleType() === EButtonStyleType.primary"
                        >
                            {{ "control_appearance_primary" | translate }}
                        </option>
                        <option
                            [value]="EButtonStyleType.secondary"
                            [selected]="styleType() === EButtonStyleType.secondary"
                        >
                            {{ "control_appearance_secondary" | translate }}
                        </option>
                        <option [value]="EButtonStyleType.custom" [selected]="styleType() === EButtonStyleType.custom">
                            {{ "control_appearance_custom" | translate }}
                        </option>
                    </select>
                </div>
                <div class="col-xs-6">
                    <div class="btn-group d-flex">
                        <sp-radio-group
                            [selected]="size()"
                            [type]="ERadioGroupType.size"
                            (changeSelectedEvent)="setSize($event)"
                        ></sp-radio-group>
                    </div>
                </div>
            </div>
        </div>

        @if (isCustomStyle()) {
            <div class="form-row mb-20">
                <sp-custom-button
                    showHoverSettings
                    [isIndependentCorners]="isIndependentCorners()"
                    [radiusSettings]="$any(advancedRadius())"
                    [advancedBorderSettings]="$any(advancedBorderSettings())"
                    [isAdvancedRadius]="true"
                    [parentBase]="$any(buttonBase())"
                    [parentHover]="$any(buttonHover())"
                    [colorsPreset]="selectedThemeColors()"
                    [buttonMode]="ButtonMode.light"
                    (valueChangeEvent)="customButtonChangeHandler($event)"
                ></sp-custom-button>
            </div>
        }

        <div class="form-row">
            @if (!isHorizontalForm()) {
                <div class="form-group mb-20">
                    <label class="col-xs-12">
                        {{ "control_width" | translate }}
                    </label>
                    <div
                        [class.col-xs-7]="widthType() === EButtonWidthType.fixed"
                        [class.col-xs-12]="widthType() !== EButtonWidthType.fixed"
                    >
                        <select class="form-control" (change)="onWidthTypeChange($event)">
                            <option [value]="EButtonWidthType.auto" [selected]="widthType() === EButtonWidthType.auto">
                                {{ "control_appearance_auto" | translate }}
                            </option>
                            <option [value]="EButtonWidthType.full" [selected]="widthType() === EButtonWidthType.full">
                                {{ "control_appearance_full" | translate }}
                            </option>
                            <option
                                [value]="EButtonWidthType.fixed"
                                [selected]="widthType() === EButtonWidthType.fixed"
                            >
                                {{ "control_appearance_fixed" | translate }}
                            </option>
                        </select>
                    </div>
                    @if (widthType() === EButtonWidthType.fixed) {
                        <div class="col-xs-5">
                            <sp-input-num
                                suffixText="px"
                                [min]="CSS_RESTRICTIONS.MIN_WIDTH_BUTTON_VALUE"
                                [value]="widthValue()"
                                (valueChange)="setWidthValue($event)"
                            ></sp-input-num>
                        </div>
                    }
                </div>
            }

            @if (isHorizontalForm()) {
                <div class="form-group mb-20">
                    <label class="col-xs-12">
                        {{ "control_width" | translate }}
                    </label>
                    <div
                        [class.col-xs-7]="horizontalFormWidthType() === EButtonWidthType.fixed"
                        [class.col-xs-12]="horizontalFormWidthType() !== EButtonWidthType.fixed"
                    >
                        <select class="form-control" (change)="onHorizontalFormWidthTypeChange($event)">
                            <option
                                [value]="EButtonWidthType.auto"
                                [selected]="horizontalFormWidthType() === EButtonWidthType.auto"
                            >
                                {{ "control_appearance_auto" | translate }}
                            </option>
                            <option
                                [value]="EButtonWidthType.full"
                                [selected]="horizontalFormWidthType() === EButtonWidthType.full"
                            >
                                {{ "control_appearance_full" | translate }}
                            </option>
                            <option
                                [value]="EButtonWidthType.fixed"
                                [selected]="horizontalFormWidthType() === EButtonWidthType.fixed"
                            >
                                {{ "control_appearance_fixed" | translate }}
                            </option>
                        </select>
                    </div>
                    @if (horizontalFormWidthType() === EButtonWidthType.fixed) {
                        <div class="col-xs-5">
                            <sp-input-num
                                suffixText="px"
                                [min]="CSS_RESTRICTIONS.MIN_WIDTH_BUTTON_VALUE"
                                [value]="widthValue()"
                                (valueChange)="setWidthValue($event)"
                            ></sp-input-num>
                        </div>
                    }
                </div>
            }

            <div>
                <sp-button-icon [buttonIcon]="$any(buttonIcon())" (valueChangeEvent)="buttonIconChangeHandler($event)">
                </sp-button-icon>
            </div>

            <div class="mb-15">
                <sp-button-additional-effects-settings
                    [additionalEffects]="$any(additionalEffects())"
                    (valueChangeEvent)="additionalEffectsChangeHandler($event)"
                >
                </sp-button-additional-effects-settings>
            </div>

            <div class="form-group" [class.mb-20]="!isShadow()" [class.mb-10]="isShadow()">
                <label class="col-xs-9 control-label">
                    {{ "control_shadow" | translate }}
                </label>
                <div class="col-xs-3 text-right">
                    <sp-switch [active]="isShadow()" (toggleActiveEvent)="setShadow($event)"></sp-switch>
                </div>
            </div>

            @if (isShadow()) {
                <sp-shadow-settings
                    [shadowSettings]="shadowSettings()"
                    (valueChangeEvent)="setShadowSettings($event)"
                ></sp-shadow-settings>
            }
        </div>
    </div>
</div>
